export default __webpack_public_path__ + "static/media/rug-seekers-partner.dd4c099e.png";